import React from 'react';
import {
  BrowserRouter as Router,
  Routes, Route, Navigate
} from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';

import Login from './pages/Login';
import VendorRegister from './pages/VendorRegister';
import CustomerRegister from './pages/CustomerRegister';
import VerifyOtp from './pages/VerifyOtp';
import AdminDashboard from './pages/AdminDashboard';
import VendorDashboard from './pages/VendorDashboard';
import CustomerPortal from './pages/CustomerPortal';
import Engineers from './pages/Engineers';
import Freelancers from './pages/Freelancers';
import Customers from './pages/Customers';
import Inventory from './pages/Inventory';
import Tickets from './pages/Tickets';
import Reports from './pages/Reports';
import VendorManagement from './pages/VendorManagement';
import AdminRequirements from './pages/AdminRequirements';
import VendorRequirements from './pages/VendorRequirements';
import LiveMap from './pages/LiveMap';
import Account from './pages/Account';
import TaskPage from './pages/TaskPage';

import Layout from './components/Layout';

const PrivateRoute = ({ children, adminOnly, vendorOrAdminOnly }) => {
  const { user, loading, isPlatformAdmin, isCustomer } = useAuth();
  if (loading) return (
    <div style={{
      display:'flex', alignItems:'center',
      justifyContent:'center', height:'100vh',
      color:'var(--accent)',
      fontFamily:'DM Mono, monospace'
    }}>
      Loading IRONWALL...
    </div>
  );
  if (!user) return <Navigate to="/login" />;
  if (adminOnly && !isPlatformAdmin)
    return <Navigate to="/dashboard" />;
  if (vendorOrAdminOnly && isCustomer)
    return <Navigate to="/dashboard" />;
  return children;
};

function AppRoutes() {
  const { user, isPlatformAdmin, isCustomer } = useAuth();

  return (
    <Routes>
      <Route path="/login" element={
        user
          ? <Navigate to="/dashboard" />
          : <Login />
      } />
      <Route path="/register" element={
        user
          ? <Navigate to="/dashboard" />
          : <VendorRegister />
      } />
      <Route path="/customer-register" element={
        user
          ? <Navigate to="/dashboard" />
          : <CustomerRegister />
      } />
      <Route path="/verify-otp" element={
        user
          ? <Navigate to="/dashboard" />
          : <VerifyOtp />
      } />
      <Route path="/task/:token" element={<TaskPage />} />
      <Route path="/" element={
        <Navigate to="/dashboard" />
      } />
      <Route path="/dashboard" element={
        <PrivateRoute>
          <Layout>
            {isPlatformAdmin
              ? <AdminDashboard />
              : isCustomer
              ? <CustomerPortal />
              : <VendorDashboard />}
          </Layout>
        </PrivateRoute>
      } />
      <Route path="/vendors" element={
        <PrivateRoute adminOnly>
          <Layout><VendorManagement /></Layout>
        </PrivateRoute>
      } />
      <Route path="/requirements" element={
        <PrivateRoute>
          <Layout>
            {isPlatformAdmin
              ? <AdminRequirements />
              : isCustomer
              ? <Navigate to="/dashboard" />
              : <VendorRequirements />}
          </Layout>
        </PrivateRoute>
      } />
      <Route path="/engineers" element={
        <PrivateRoute vendorOrAdminOnly>
          <Layout><Engineers /></Layout>
        </PrivateRoute>
      } />
      <Route path="/freelancers" element={
        <PrivateRoute vendorOrAdminOnly>
          <Layout><Freelancers /></Layout>
        </PrivateRoute>
      } />
      <Route path="/customers" element={
        <PrivateRoute vendorOrAdminOnly>
          <Layout><Customers /></Layout>
        </PrivateRoute>
      } />
      <Route path="/inventory" element={
        <PrivateRoute vendorOrAdminOnly>
          <Layout><Inventory /></Layout>
        </PrivateRoute>
      } />
      <Route path="/tickets" element={
        <PrivateRoute vendorOrAdminOnly>
          <Layout><Tickets /></Layout>
        </PrivateRoute>
      } />
      <Route path="/map" element={
        <PrivateRoute vendorOrAdminOnly>
          <Layout><LiveMap /></Layout>
        </PrivateRoute>
      } />
      <Route path="/reports" element={
        <PrivateRoute vendorOrAdminOnly>
          <Layout><Reports /></Layout>
        </PrivateRoute>
      } />
      <Route path="/account" element={
        <PrivateRoute vendorOrAdminOnly>
          <Layout><Account /></Layout>
        </PrivateRoute>
      } />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}

export default App;
